// extracted by mini-css-extract-plugin
export default {"canNotDeleteModal":"CanNotDeleteClient_canNotDeleteModal__tNNep"};